// extracted by mini-css-extract-plugin
module.exports = {"employeeRowActionIcon":"_2g_mk","statusModalUser":"_3unLu"};